<template>
    <div class="flex items-center cursor-pointer hover:text-default relative" @click="open()" v-click-outside="close">
        <div v-if="(teachers ?? []).length === 0" class="teachers__img-">
            <img class="img" src="@/assets/svg/teacher.svg">
        </div>
        <template v-else>
            <div v-for="(item, index) in teachers.slice(0, 5)" :key="index" class="teachers__img" v-tooltip="{ content: `${item.fullname}<br/>${item.email}`, html: true}">
              <img :src="item.img || item.profileImageUrlSmall" class="img">
            </div>
            <div class="teachers__img teachers__count" v-if="teachers.length > 5">
                +{{ teachers.length - 5 }}
            </div>
        </template>

        <div class="teachers__label- text-sm pl-4">
            {{ t('teachersComp.title') }}
        </div>

        <Transition name="teachers__animation">
            <div class="teachers__content" v-if="showTeachersPopup">
                <h3 class="teachers__title">{{ t('teachersComp.title') }}</h3>
                <Spinner v-if="loading" />
                <div v-if="!!errorMessage">
                    {{ errorMessage }}
                </div>
                <ul v-else class="teachers__list pl-0">
                    <li
                        class="teachers__item- flex pb-2"
                        v-for="(item, index) in teachers"
                        :key="index"
                        :class="{'teachers__item_active' : index === activeTeacher}"
                        @click="chosenTeacher(index); navToTeacher(item)"
                    >
                        <div class="teachers__img">
                            <img :src="item.img || item.profileImageUrlSmall" class="img">
                        </div>
                        <div class="pl-4">
                            <div class="teachers__name">{{ item.fullname }}</div>
                            <div class="teachers__mail">{{item?.email}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </Transition>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n"
import Spinner from "@/components/Spinner.vue"

export default {
    name: 'Teachers',

    components: { Spinner },

    data: () => ({
        activeTeacher: null,
        activeContent: false,
        teachers: null,
        loading: false,
        showTeachersPopup: false,
        errorMessage: null
    }),
    props: {
        courseid: {
            type: [Number, String],
            default: null
        },
        autofetch: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        teachers () {
            this.$emit('update:modelValue', this.teachers)
        }
    },

    created () {
        if (this.autofetch) this.fetchTeachers()
    },

    methods: {
        async fetchTeachers () {
            this.teachers = []
            if (!this.courseid) return

            try {
                this.loading = true
                await this.$store.dispatch("getCourseTeachers", this.courseid).then(({ teacher, manager, error }) => {
                    this.teachers = teacher || []
                    if (error) this.errorMessage = error
                })
            } finally {
                this.loading = false
            }
        },
        chosenTeacher(index) {
            this.activeTeacher = index
        },
        open () {
            if (this.teachers === null) {
                this.fetchTeachers()
            }
            this.showTeachersPopup = true
        },
        close() {
            this.showTeachersPopup = false
        },
        navToTeacher(item) {
            this.$router.push(`/profile/${item.id}`)
        },
        getTeachers () {
            return this.teachers
        }
    },
    setup() {
        const {t} = useI18n()
        return {
            t
        }
    }
}
</script>

<style scoped lang="scss">
@import './scss/teachers.scss';
</style>
